module.exports = __webpack_public_path__ + "img/nl.ccd6451f.svg";